module.exports = {
      id: "f264643c29d16550300f35123f614462sewerage-sump.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#f264643c29d16550300f35123f614462sewerage-sump.svg",
      toString: function () {
        return this.url;
      }
    }